import APIHelper from "helpers/APIHelper";
import { IPartKey } from "helpers/interfaces";
import { IProductNavigatorNode, IProductNavigatorParentNode, IProductNavigatorPartFilter, IProductNavigatorPartFilterPart } from "models/IProductNavigator";

export default class ProductNavigatorAPI {
    
    public static async ProductNavigator(oKey: number, callSize: string, partList: IPartKey[] | null): Promise<IProductNavigatorNode[]> {
        const url: string = `api/ProductNavigator/${oKey}`;
        const params = {
            callSize,
            partList
        }
        const response = await APIHelper.PostAsync<IProductNavigatorNode[]>(url, undefined, params);
        return response.Result;
    }
    
    public static async CallSizes(oKey: number, partList: IPartKey[] | null): Promise<string[]> {
        const url: string = `api/ProductNavigator/${oKey}/CallSizes`;
        const response = await APIHelper.PostAsync<string[]>(url, undefined, partList);
        return response.Result;
    }
    
    public static async ParentNodes(): Promise<IProductNavigatorParentNode[]> {
        const url: string = `api/ProductNavigator/ParentNodes`;

        const response = await APIHelper.GetAsync<IProductNavigatorParentNode[]>(url);
        return response.Result;
    }

    public static async PartFilters(filterID: number, oKey: number): Promise<IProductNavigatorPartFilter[]>
    {
        const url: string = `api/ProductNavigator/PartFilter/${filterID}/${oKey}`;

        const response = await APIHelper.GetAsync<IProductNavigatorPartFilter[]>(url);
        return response.Result;
    }

    public static async PartFilterValues(filterID: number, selectedValues: IProductNavigatorPartFilter[]): Promise<string[]>
    {       
        const url: string = `api/ProductNavigator/PartFilter/${filterID}/PartFilterValues`;

        const response = await APIHelper.PostAsync<string[]>(url, undefined, selectedValues);
        return response.Result;
    }

    public static async PartFilterParts(filterID: number, oKey: number, selectedValues: IProductNavigatorPartFilter[]): Promise<IProductNavigatorPartFilterPart[]>
    {
        const url: string = `api/ProductNavigator/PartFilter/${filterID}/PartFilterParts/${oKey}`;

        const response = await APIHelper.PostAsync<IProductNavigatorPartFilterPart[]>(url, undefined, selectedValues);
        return response.Result;
    }
}